import React from 'react';
import { BrowserRouter, Routes, Route} from 'react-router-dom';


import './App.scss';
import { Navbar } from './components';
import { Benefit, Contact, Home, NotFound } from './pages'


const App = () => {
  return (
    <>
        <BrowserRouter>
                <div className={`bg-main-bg w-full`}>
                    <Navbar />
                </div>
                
                <div>
                    <Routes>
                        {/* Home */}
                        <Route path='/'        element={<Home />}/>

                        {/* Pages */}
                        <Route path='/benefit'     element={<Benefit />}/>
                        <Route path='/contact'     element={<Contact />}/>
                        <Route path='*'           element={<NotFound />}/>
                    </Routes>
                </div>
           
        </BrowserRouter>
    </>
  )
}

export default App